<template>
  <div id="lawmap">
    <span class="my-position">我的位置</span>
  </div>
</template>


<style lang="scss" rel="stylesheet/scss">

  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';

  #lawmap{
    position: relative;
    width: 100%;
    height: 100%;
    .my-position {
      position: absolute;
      right: 50px;
      bottom: 25px;
      color: black;
      font-size: 20px;
      z-index: 99999999;
    }
  }

  .circle,
  .stract {
    position: absolute;
    width: 80px;
    height: 80px;
    padding: 24px 0;
    border-radius: 50%;
    background-color: $brand;
    opacity: .9;
    text-align: center;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 0 2px rgba(0,0,0,.5);
    &:hover {
      background-color: $brand-red;
      opacity: 1;
    }
  }
  .stract {
    background-color: $brand-blue;
    &:hover {
      background-color: $brand-teal;
      opacity: 1;
    }
  }
  .dot {
    width: 19px;
    height: 33px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    &.ls {
      background-image: url(../../static/images/ls.png);
    }
    &.sj {
      background-image: url(../../static/images/sj.png);
    }
    &.gz {
      background-image: url(../../static/images/gz.png);
    }
    &.fy {
      background-image: url(../../static/images/fy.png);
    }
    &.rm {
      background-image: url(../../static/images/rm.png);
    }
  }
  .amap-info{
    .amap-adcontent-body{
      border: none;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 0 30px rgba(0,0,0,.2);
      box-sizing: border-box;
    }
    .amap-adcombo-close{
      top: 15px;
      right: 15px;
      background: url(../../static/images/close.png) 0 0 no-repeat;
      &:hover{
        background-position: 0 -18px;
      }
    }
    .amap-info-combo{
      padding-bottom: 5px;
      background: $white;
      .keyword-input,
      .search-button{
        box-sizing: content-box;
      }
    }
    .amap-info-combo .tab {
      border-color: $gray-lighter;
      font-size: 15px;
      .tab-icon {
        display: none;
      }
    }
  }
  .card {
    overflow: hidden;
    position: relative;
    width: 350px;
    border-radius: 5px 5px 0 0;
    .card-heading {
      width: 100%;
      height: 124px;
      text-align: center;
      background: url(../../static/images/card-bg.png) center top no-repeat;
      background-size: 100% auto;
    }
    .card-body {
      padding-bottom: 10px;
    }
    .tag {
      position: absolute;
      top: 13px;
      left: 0;
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      height: 26px;
      line-height: 24px;
      border-top: 1px solid rgba($white,.25);
      border-bottom: 1px solid rgba($white,.25);
      color: white;
      background-color: rgba($white,.2);
      &:after {
        content: '';
        position: absolute;
        right: -7px;
        top: -1px;
        width: 7px;
        height: 26px;
        background: url(../../static/images/tag-bg.png) top left no-repeat;
      }
    }
    .readmore {
      display: inline-block;
      margin: 55px auto 35px auto;
      padding: 5px 15px;
      font-size: $font-size-large;
      border-radius: 3px;
      border: 1px solid rgba($white,.2);
      font-weight: 100;
      color: $white;
      background-color: rgba($white,.1);
      transition: all .18s ease-in;
      &:hover {
        box-shadow: 0 0 50px rgba(0,0,0,.08);
      }
    }
    .title {
      margin-bottom: 10px;
      padding: 10px 15px;
      font-size: $font-size-h4;
      border-bottom: 1px solid $gray-lighter;
      font-weight: bolder;
      color: $gray-dark;
      background-color: #f8f8f8;
      span {
        width: 80%;
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .title-a {
        display: inline-block;
        height: 100%;
        margin-top: 5px;
        float: right;
        font-size: 13px;
      }
    }
    .desc {
      position: relative;
      padding-left: 35px;
      padding-right: 15px;
      line-height: 100%;
      font-size: 15px;
      color: $gray-light;
      .iconfont {
        position: absolute;
        left: 15px;
        top: 1px;
        color: $brand-blue;
      }
    }
    .card-filter {
      margin: 0;
      padding: 0;
      list-style: none;
      overflow: hidden;
      display: none;
      .card-item {
        float: left;
        width: 25%;
        text-align: center;
        border-right: 1px solid #e6e5ea;
      }
      .count {
        font-size: 20px;
        color: #15bb7e;
      }
      .text {
        font-size: 12px;
        color: #888;
      }
    }
    .card-btns {
      margin: 0;
      padding: 18px;
      list-style: none;
      overflow: hidden;
      display: none;
      li {
        float: left;
        margin-left: 10px;
        &:first-child {
          margin-left: 0;
        }
      }
      .card-btn {
        display: block;
        width: 90px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border-radius: $border-radius-base;
        font-size: $font-size-large;
        color: $white;
        &.card-btn-1 {
          background-color: #3387ce;
        }
        &.card-btn-2 {
          background-color: #2db694;
        }
        &.card-btn-3 {
          background-color: #dc772c;
        }
      }
    }
    .tel-phone-box {
      position: relative;
      padding: 0 18px;
      margin-top: 20px;
      margin-bottom: 18px;
    }
    .tel-phone {
      position: relative;
      padding: 10px 0 8px;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #c2cad7;
      box-sizing: border-box;
      font-size: 28px;
      color: #51638a;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .tel-phone-title {
      position: absolute;
      left: 50%;
      top: -10px;
      padding: 0 14px;
      transform: translate(-50%, 0);
      background-color: $white;
      font-size: $font-size-base;
      color: #51638a;
      z-index: 888888;
      .iconfont {
        margin-right: 8px;
      }
    }
  }
  .infowindow-content {
    position: relative;
    padding: 10px;
    margin-bottom: -4px;
    .amap-info-header {
      padding: 0 12px 0 85px;
      font-size: $font-size-h4;
      color: $gray-dark;
      a {
        cursor: pointer;
      }
    }
    .amap-info-body{
      p{
        margin: 8px 0 0;
        padding-left: 85px;
      }
    }
  }
  .img-warp {
    position: absolute;
    left: 0;
    top: 1px;
    width: 90px;
    height: 100%;
    background: url("../../static/images/default_org.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    a {
      position: absolute;
      left: 0;
      bottom: 0;
      display: block;
      width: 100%;
      height: 20px;
      text-align: center;
      line-height: 20px;
      cursor: pointer;
      color: $white;
      &.firm {
        background: #348ac7;
      }
      &.mediate {
        background: #009900;
      }
      &.judicial {
        background: #ec4040;
      }
      &.office {
        background: #1ab99b;
      }
      &.service {
        background: #f0b302;
      }
    }
  }
  .amap-icon {
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>

<script>
export default {
  props: ['zoomCode', 'markers', 'createWindow', 'lawyerMarkers', 'zoomCityShow', 'infowindow', 'getLawyer'],
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// map.vue?32f23ea8